import { getPublicEnv, PublicEnvKeys } from '../utils/PublicEnv/getPublicEnv';

// opt-in: set UA_DPOP_AUTH_ENABLED=true on a release to turn the whole feature on
// a function, not a const — the value can land on `window` after this module is evaluated,
// and a const would freeze the default for the rest of the session
export const isDpopAuthEnabled = (): boolean =>
  getPublicEnv(PublicEnvKeys.DPOP_AUTH_ENABLED, false);
